import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'autoReport'
})
export class AutoReportPipe implements PipeTransform {
  transform(value: boolean): string {
    return value === true ? 'ON' : 'OFF';
  }
}
